import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router'; 
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';

@Component({
  selector: '[mft-widget]',
  templateUrl: "./widget.component.html"
})
export class WidgetComponent implements OnInit, AfterViewInit {
  public currenturl: string = "";
  public compareurl: string = "";
  public driversclub: string = "driversclub";
  public mybusinessadvantage: string = "mybusinessadvantage";
  public myfleetsolutions: string = "myfleetsolutions";
  public myfuelcardaccount: string = "myfuelcardaccount";

  constructor(private authService: AuthService, private appCommonService: AppCommonService, private router: Router) {

  }
  ngOnInit() {
    this.compareurl = this.router.url.toString().toLowerCase();
    if (this.compareurl.indexOf(this.driversclub) != -1) {
      this.currenturl = this.driversclub;
    }
    else if (this.compareurl.indexOf(this.mybusinessadvantage) != -1)
    {
      this.currenturl = this.mybusinessadvantage;
    }
    else if (this.compareurl.indexOf(this.myfleetsolutions) != -1) {
      this.currenturl = this.myfleetsolutions;
    }
    else if (this.compareurl.indexOf(this.myfuelcardaccount) != -1) {
      this.currenturl = this.myfuelcardaccount;
    }
  }

  ngAfterViewInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/genericpages/widget.component.ts